export { Legend } from './Legend.component';
